import React from 'react';

import { CardId } from '@/console/features/card-layout/card-layout.types';
import { RecentDevicesCard } from '@/console/features/card-layout/components/recent-devices-card/recent-devices-card';
import { RecentGroupsCard } from '@/console/features/card-layout/components/recent-groups-card/recent-groups-card';
import { RecentPipelinesCard } from '@/console/features/card-layout/components/recent-pipelines-card/recent-pipelines-card';
import { RecentProjectsCard } from '@/console/features/card-layout/components/recent-projects-card/recent-projects-card';

export const renderCards = (cardId: CardId): React.ReactNode => {
  switch (cardId) {
    case CardId.PROJECTS:
      return <RecentProjectsCard />;
    case CardId.DEVICES:
      return <RecentDevicesCard />;
    case CardId.PIPELINES:
      return <RecentPipelinesCard />;
    case CardId.GROUPS:
      return <RecentGroupsCard />;
    default:
      return null;
  }
};
